import React from "react";
import { Field } from "react-final-form";
import * as palette from "@govlaunch/palette";
import { Input } from "@govlaunch/core";
import { IFormFieldProps } from "~/components/form/FormFieldProps";
import FieldValidationError from "~/components/form/FieldValidationError";
import CharacterLimitIndicator from "~/components/form/CharacterLimitIndicator";

export default function TextField({
  fieldName,
  label,
  placeholder,
  characterLimit,
  showCharacterCount,
  ...props
}: IFormFieldProps) {
  return (
    <Field name={fieldName}>
      {({ input, meta }) => (
        <div>
          {label && (
            <div
              css={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                css={{
                  fontWeight: 500,
                  fontSize: 14,
                  color: palette.mediumGray,
                  margin: 0,
                }}
              >
                {label}
              </label>

              <FieldValidationError meta={meta} />
            </div>
          )}

          <Input
            css={{
              marginTop: label ? 8 : 0,
              height: 42,
              borderRadius: 5,
              border: `1px solid ${palette.lightestGray}`,
              fontSize: 14,
              padding: "6px 12px",
              width: "100%",
              outline: 0,
              "::placeholder": {
                color: palette.sealBlue,
              },
              ":focus": {
                borderColor: palette.primary,
              },
            }}
            maxLength={characterLimit}
            placeholder={placeholder}
            {...input}
            {...props}
          />

          {characterLimit && showCharacterCount && (
            <div
              css={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: 8,
              }}
            >
              <CharacterLimitIndicator
                maxLength={characterLimit}
                description={input.value}
                css={{
                  marginLeft: "auto",
                }}
              />
            </div>
          )}
        </div>
      )}
    </Field>
  );
}
